import {withBase} from "ufo";

export const absoluteIfPossible = (url: string) => {
    const runtimeConfig = useRuntimeConfig();
    // TODO: Look in to site config setup
    const base = runtimeConfig?.public?.i18n?.baseUrl;
    return withBase(url, base);
}
